import React from "react";
import HeaderComponent from "components/card/HeaderComponent";
import BarChartBase from "components/charts/BarChartBase";



const PayrollOverview = () => {
const data = [
    { month: "May", amount: 0 },
    { month: "Jun", amount: 0 },
    { month: "Jul", amount: 0 },
];

  return (
    <HeaderComponent
      title="Payroll Overview"
      description="Monthly payroll expenses"
    >
      <BarChartBase
        data={data}
        xKey="month"
        height={300}
        yKey="amount"
        useGradient={true}
        textSize={14}
      />
   </HeaderComponent>
  );
};

export default PayrollOverview;
